var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._b({staticClass:"fas fa-question-circle text-primary ml-1",attrs:{"data-toggle":"tooltip"}},'i',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }